import React from "react";
import { Col, Row } from "react-bootstrap";
import Langs from "../../../app/lang/langs";
import ProgressView from "../ProgressView";
import { ThemeButton } from '../../buttons/ThemeButton';

/**
 * ProgressTab - Renders the project progress view (case 6).
 * Only visible in edit mode. Contains the ProgressView component and navigation.
 */
export default function ProgressTab({
    isMobile,
    mode,
    setActiveIndex,
}) {
    return (
        <div>
            <div
                className={`card p-3 m-4 d-flex  align-content-center border-0`}
                style={isMobile === 2 ? { height: 'calc(85vh - 300px)', display: 'flex', flexDirection: 'column' } : {}}
            >
                <ProgressView />
                {isMobile === 2 && mode == "edit" && (
                    <Row className="mt-2 d-flex justify-content-center" style={{ width: '100%' }}>
                        <Col xs={6} className="d-flex justify-content-center">
                            <ThemeButton title={<Langs str="Next" />} active={true} onClick={() => { setActiveIndex(0) }} style={{ width: '48%' }} />
                        </Col>
                    </Row>)}
            </div>
            {isMobile !== 2 && mode === "edit" && (
                <div>
                    <div style={{
                        position: 'fixed',
                        bottom: '1.5rem',
                        right: isMobile === 3 ? '3rem' : '1.5rem',
                        width: isMobile === 3 ? '15%' : '7%'
                    }}>
                        <ThemeButton
                            title="Next"
                            active={true}
                            onClick={() => { setActiveIndex(0) }}
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
